import { useEffect } from "react";

const APP_NAME = "Polypup";

// usePageTitle sets the browser tab title while a page is shown: the page's
// own title followed by the app name, or just the app name for null.
export function usePageTitle(title: string | null) {
  useEffect(() => {
    document.title = title ? `${title} · ${APP_NAME}` : APP_NAME;
  }, [title]);
}
